export default {
  endpoint: "https://app.crmicon.com",
  socket: "https://socket.crmicon.com",
  appName: "crmicon",
  PUSHER_APP_ID: "crmicon",
  PUSHER_CHNL_ID: "crmicon",
  PUSHER_APP_KEY: "crmicon-key",
  PUSHER_WS_HOST: "pusher.crmicon.com",
  PUSHER_WS_PORT: 443,
  PUSHER_WSS_PORT: 443,
};
